<lib-generic-dropdown-multiselect
    [source]="items"
    [(selectedItems)]="selectedItems"
    (selectedItemsChange)="onSelectedItemsChange($event)"
    [config]="{
        multiple: true,
        defaultText: 'Select ' + label,
        itemDisplayKey: additionalInfo?.itemDisplayKey ?? 'name'
    }"
    [removeKey]="'name'"
    [isReadOnly]="isReadOnly"
    [error]="!isValid"
>
</lib-generic-dropdown-multiselect>
